export const instanceName = 'ApplicationSearchGeneral'

export const formName = 'frm_application'

export const APPLICATION_DELETE_CONFIRMATION_MODAL_NAME = 'APPLICATION_DELETE_CONFIRMATION'

export const APPLICATION_DELETE_FETCHER_NAME = 'APPLICATION_DELETE'

export const COMMITTEE_DELETE_MODAL = 'CommitteeDeleteModal'

export const RETURN_REVIEW_MODAL = 'RETURN_APP_REVIEW'

export const SEND_COMMITTEE_MODAL = 'SEND_APP_COMMITTEE'
